import { AssessmentOverviewQuestionnaireItem } from '../sections/assessment-overview/questionnaire'
import { PatientOverviewQuestionnaireItem } from '../sections/patient-overview/questionnaire'
import { MedicationsQuestionnaireItem } from '../sections/medications/questionnaire'
import { MedicalBackgroundQuestionnaireItem } from '../sections/medical-background/questionnaire'
import { DischargeSummaryQuestionnaireItem } from '../sections/discharge-summary/questionnaire'
import { FinalStepsQuestionnaireItem } from '../sections/final-steps/questionnaire'

// Amalgamate all section questionnaire enums
export const DischargeAssessmentQuestionnaireItem = {
  ...AssessmentOverviewQuestionnaireItem,
  ...PatientOverviewQuestionnaireItem,
  ...MedicationsQuestionnaireItem,
  ...MedicalBackgroundQuestionnaireItem,
  ...DischargeSummaryQuestionnaireItem,
  ...FinalStepsQuestionnaireItem
} as const

export type DischargeAssessmentQuestionnaireItem =
  (typeof DischargeAssessmentQuestionnaireItem)[keyof typeof DischargeAssessmentQuestionnaireItem]
